function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isFinite = Number.isFinite;
export var isNull = function isNull(value) {
  return value === null;
};
export var isUndefined = function isUndefined(value) {
  return typeof value === 'undefined';
};
export var isNullOrUndefined = function isNullOrUndefined(value) {
  return isNull(value) || isUndefined(value);
};
export var isAssigned = function isAssigned(value) {
  return !isNullOrUndefined(value);
};
export var isString = function isString(value) {
  return typeof value === 'string';
};
export var isNumber = function isNumber(value) {
  return typeof value === 'number' && isFinite(value);
};
export var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};
export var isSymbol = function isSymbol(value) {
  return _typeof(value) === 'symbol';
};
export var isBigInt = function isBigInt(value) {
  return typeof value === 'bigint';
};
export var isPrimitives = function isPrimitives(value) {
  var t = _typeof(value);

  return value === null || t === 'undefined' || t === 'string' || t === 'number' && isFinite(value) || t === 'boolean' || t === 'symbol' || t === 'bigint';
};
export var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
export var isObject = function isObject(value) {
  return value !== null && _typeof(value) === 'object';
};
export var objectToString = Object.prototype.toString;
export var toTypeString = function toTypeString(value) {
  return objectToString.call(value);
};
var hasOwnProperty = Object.prototype.hasOwnProperty;
export var hasOwn = function hasOwn(value, key) {
  return hasOwnProperty.call(value, key);
};
export var toRawType = function toRawType(value) {
  return toTypeString(value).slice(8, -1);
};
export var isPlainObject = function isPlainObject(value) {
  return toTypeString(value) === '[object Object]';
};
export var isArray = Array.isArray;
export var isMap = function isMap(value) {
  return toTypeString(value) === '[object Map]';
};
export var isSet = function isSet(value) {
  return toTypeString(value) === '[object Set]';
};
export var isPromise = function isPromise(value) {
  return isObject(value) && isFunction(value.then) && isFunction(value.catch);
};
export var isDate = function isDate(value) {
  return value instanceof Date;
};